/**
 * **A card's one big figure** — the value, the small "/24" beside it and the small " dni" after it,
 * in the danger ink when the figure is bad news in itself. Every surface that draws the figure draws
 * it this way; the size and the ink are the host's, so the host hands over its own stylesheet, which
 * names `.value`, `.danger` and `.small`.
 */

import type { TaskHero } from '../model/taskContent';

export function HeroFigure({ hero, skin }: { readonly hero: TaskHero; readonly skin: CSSModuleClasses }) {
  return (
    <b className={`${String(skin.value)} ${hero.danger ? String(skin.danger) : ''}`}>
      {hero.value}
      {hero.total === null ? null : <small className={skin.small}>{hero.total}</small>}
      {hero.unit === null ? null : <small className={skin.small}> {hero.unit}</small>}
    </b>
  );
}
